import { ReactElement } from 'react';
import {
    UIIcon,
    UIMenu,
    UIMenuHeader,
    UIMenuItem,
    UIPopover,
    UIPressableAreaButtonLess
} from '@/ui';
import styles from './notifications-icon.module.scss';
import { charcoal } from '@/ui/styles';
import { useCommonTranslation, useNotificationSettings } from '../hooks';

export function NotificationsIcon(): ReactElement {
    const { t } = useCommonTranslation();
    const {
        showAlertPopup,
        playAlertSound,
        setShowAlertPopup,
        setPlayAlertSound
    } = useNotificationSettings();

    return (
        <UIPopover
            placement="bottom_left"
            popoverPadding={4}
            trigger="click"
            triggerNode={
                <button className={styles.removeButtonStyle}>
                    <UIPressableAreaButtonLess>
                        <UIIcon name="bell" size={18} color={charcoal} />
                    </UIPressableAreaButtonLess>
                </button>
            }
        >
            <UIMenu>
                <UIMenuHeader text={t('components.notifications_icon.title')} />
                <UIMenuItem
                    text={t('components.notifications_icon.show_alert_popup')}
                    onClick={() => {
                        setShowAlertPopup(!showAlertPopup);
                    }}
                    switchProps={{
                        small: true,
                        checked: showAlertPopup
                    }}
                />
                <UIMenuItem
                    text={t('components.notifications_icon.play_alert_sound')}
                    onClick={() => {
                        setPlayAlertSound(!playAlertSound);
                    }}
                    switchProps={{
                        small: true,
                        checked: playAlertSound
                    }}
                />
            </UIMenu>
        </UIPopover>
    );
}
